import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SelectProps } from 'ant-design-vue'
import { getCosIdBindCode as getCosIdBindCodeFbu } from '@/api/gucangSales/customerCenter'
import { getCosIdBindCode as getCosIdBindCodeOfbu } from '@/api/overseasSales/customerCenter'
import { debounce } from 'lodash-es'

const __default__ = { name: 'CodeSelect' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: [String, Number, Array]
  },
  label: String,
  cosId: {
    type: String
  },
  view: {
    type: Boolean
  },
  stage: {
    type: Array,
    default: () => {
      return [2, 3, 4] // 2.潜在 3签约 4 成交
    }
  },
  requiredCosId: {
    type: Boolean,
    default: true
  },
  isEmpty: {
    type: Boolean,
    default: false
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
},
  emits: ['update:value', 'update:label', 'update:isEmpty'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props
const getCosIdBindCodeMethod = {
  cos_fbu: getCosIdBindCodeFbu,
  cos_ofbu: getCosIdBindCodeOfbu
}
const pageNumber = ref(1)
const data = ref()
const searchTxt = ref()
const emit = __emit
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
watch(
  () => props.cosId,
  (v, prev) => {
    if (v && v !== prev) {
      optionPage.value = []
      if (prev) {
        data.value = undefined
        emit('update:label', undefined)
        emit('update:value', undefined)
      }
      fetch()
    }
  }
)
const change: SelectProps['onChange'] = (value) => {
  const find = optionPage.value.find((item) => item.id === value)
  emit('update:label', find?.arkCode)
  emit('update:value', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const fetchCode = debounce((txt: string) => {
  searchTxt.value = txt
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  getCosIdBindCodeMethod[props.appId]({
    pageNumber: pageNumber.value,
    pageSize: 100,
    stage: props.stage,
    cosId: props.cosId
  }).then((res: any) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
    emit('update:isEmpty', optionPage.value.length === 0)

    // 详情页回显的时候，判断下拉列表中是否包含当前值，如果没有，则将详情数据添加到列表并设置不可选
    if (props.label && props.value) {
      const find = optionPage.value.find((item) => item.id === props.value)
      if (!find) optionPage.value.unshift({ id: props.value, arkCode: props.label, disabled: true })
    }
  })
}
onMounted(() => {
  if (props.requiredCosId && !props.cosId) {
    return
  }
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!

  return (_openBlock(), _createBlock(_component_CosSelect, _mergeProps({
    value: data.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event))
  }, _ctx.$attrs, {
    style: {"width":"100%"},
    onPopupScroll: popupScroll,
    showSearch: true,
    "filter-option": false,
    onSearch: _unref(fetchCode),
    placeholder: _unref(t)('common.pleaseSelect'),
    onChange: change,
    view: __props.view,
    fieldNames: { label: 'arkCode', value: 'id' },
    options: optionPage.value
  }), null, 16, ["value", "onSearch", "placeholder", "view", "options"]))
}
}

})